var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.21 9.21a.992.992 0 0 0 0-1.404L6.405 5 9.21 2.194A.992.992 0 0 0 7.807.791L5 3.596 2.195.791A.992.992 0 1 0 .792 2.194L3.598 5 .791 7.806A.992.992 0 1 0 2.194 9.21l2.807-2.806 2.807 2.806a.992.992 0 0 0 1.403 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgCross;